import { render } from "./Pmf.vue?vue&type=template&id=a5333fce&scoped=true"
const script = {}

import "./Pmf.vue?vue&type=style&index=0&id=a5333fce&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5333fce"]])

export default __exports__